import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { StorageService } from './storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';

export const ORDER_NUMBER_QUERY = gql`
  query GetOrderNumber($businessId: String) {
    GetOrderNumber(businessId: $businessId) {
      id
      businessId
      counter
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class OrderNumberService {
  constructor(private apollo: Apollo, private storageService: StorageService) {}

  getCounters() {
    return this.apollo.watchQuery({
      query: ORDER_NUMBER_QUERY,
      variables: {
        businessId: this.storageService.getLocalStorageData(
          LOCAL_STORAGE.BUSINESS_VALUES
        ).businessId,
      },
      fetchPolicy: 'network-only',
    });
  }

  getNumber() {
    return new Promise((resolve) => {
      this.getCounters().valueChanges.subscribe((response: any) => {
        console.log(response);
        resolve(
          response.data.GetOrderNumber.counter.toString().padStart(4, '0')
        );
      });
    });
  }
}
